import { render } from "./MyGroup.vue?vue&type=template&id=29a99d2a&scoped=true&ts=true"
import script from "./MyGroup.vue?vue&type=script&lang=ts"
export * from "./MyGroup.vue?vue&type=script&lang=ts"

import "./MyGroup.vue?vue&type=style&index=0&id=29a99d2a&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a99d2a"]])

export default __exports__